import React from 'react';
import { InfoMessage, Loading } from '@fasstech/middle-design-system';

const CcnOfferInfos = ({ loadingCcnOffer, showInfoMessage, ccnOffer, getMiddleText }) => {
  return (
    <div className={'w-1/2'}>
      {loadingCcnOffer ? (
        <div className="flex items-center justify-center w-full">
          <Loading />
        </div>
      ) : (
        showInfoMessage && (
          <InfoMessage iconName="lightbulb">
            {ccnOffer
              ? getMiddleText('ENTREPRISE_CCN_OFFRE_ASSUREUR_MESSAGE_INFO')
              : getMiddleText('ENTREPRISE_CCN_PAS_OFFRE_ASSUREUR_MESSAGE_INFO')}
          </InfoMessage>
        )
      )}
    </div>
  );
};

export default CcnOfferInfos;
